export const apiField = 'client_address';
export default {
  type: 'Text',
  label: 'clientAddress',
  missing: undefined,
  apiField,
  tooltip: undefined,
};